// extracted by mini-css-extract-plugin
module.exports = {"finishSetup":"_1t4A1","header":"PyI6S","appCard":"_2zPEp","column":"_2qwly","addToSite":"_3Xog6","manageAppsLink":"_3x4kg"};